<template>
<div class="chapter">
<div class="inner_page">
<p class="copy"><a id="page_iv"></a><a id="ch00_fm04_copy"></a><strong><span class="small">NEW YORK UNIVERSITY PRESS</span></strong><br/>New York and London</p>
<p class="copy1">© 2003 by New York University</p>
<p class="copy2">All rights reserved</p>
<p class="copy1">Library of Congress Cataloging-in-Publication Data</p>
<p class="copy1">Religion and the creation of race and ethnicity : an introduction/</p>
<p class="copy2">edited by Craig R. Prentiss.</p>
<p class="copy2">p. cm. — (Religion, race, and ethnicity)</p>
<p class="copy2">Includes bibliographical references.</p>
<p class="copy1">ISBN 0-8147-6700-1 (cloth : alk. paper) — ISBN 0-8147-6701-X (pbk.: alk. paper)</p>
<p class="copy2">1. Ethnicity—Religious aspects.   I. Prentiss, Craig R.   II. Series.</p>
<p class="copy2">BL65.E75 R47 2003</p>
<p class="copy2">291.1’78348—dc21      2002152479</p>
<p class="copy1">New York University Press books are printed on acid-free paper,</p>
<p class="copy2">and their binding materials are chosen for strength and durability.</p>
<p class="copy1">Manufactured in the United States of America</p>
<p class="copy2">10 9 8 7 6 5 4 3 2 1</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm04_copy.vue?6a495e04